module.exports = __webpack_public_path__ + "media/blog/other-post-bg-de11ff5e.png";